import React from "react"
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Row,
  Col,
  Button,
  Alert
} from "reactstrap"
import { BrowserView, MobileView } from "react-device-detect"
import { withRouter } from "react-router"
import { flowRight as compose } from "lodash"
import { useMutation } from "@apollo/react-hooks"
import { useQueryData } from "utils"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { withBasicNotify } from "components/notification"
import withModal from "components/modal"
import { BarLoader } from "components/spinner"
import DetailHeader from "components/order-detail-header"
import DetailItemList from "components/order-detail-item-list"
import DetailItem from "components/order-detail-item"
import { GET_ORDER, UPDATE_ORDER_DETAILS, UPDATE_ORDER } from "../gql"

const OrderAuditClContainer = props => {
  const { data, writeData } = useQueryData(GET_ORDER, {
    fetchPolicy: "cache-and-network",
    variables: {
      id: props.match.params.id
    }
  })
  const [
    updateOrderDetails,
    { loading: updateOrderDetailsLoading, error: updateOrderDetailsError }
  ] = useMutation(UPDATE_ORDER_DETAILS, {
    variables: {
      orderId: props.match.params.id,
      updateOrderDetailInputs:
        data?.order?.orderDetails.map(orderDetail => {
          return {
            ...orderDetail,
            __typename: undefined,
            product: undefined,
            unitPrice: undefined,
            sum: undefined
          }
        }) || []
    },
    refetchQueries: [
      {
        query: GET_ORDER,
        variables: {
          id: props.match.params.id
        }
      }
    ]
  })
  const [
    updateOrder,
    { loading: updateOrderLoading, error: updateOrderError }
  ] = useMutation(UPDATE_ORDER)

  useBread({ to: props.match.url, name: "詳細資訊" })

  const updateOrderVariables = status => {
    return {
      variables: {
        id: props.match.params.id,
        input: { status }
      },
      refetchQueries: [
        {
          query: GET_ORDER,
          variables: {
            id: props.match.params.id
          }
        }
      ]
    }
  }

  const onUpdate = () => {
    const { modal, notify } = props
    modal.setCentered(false)
    modal.setHeaderText("系統提示")
    modal.setModalContent("是否確定更新詢價單內容？")

    modal.setOnSubmit(async () => {
      await updateOrderDetails()

      notify.success("詢價單更新成功")
    })
    modal.toggle()
  }

  const onCancel = () => {
    const { modal, notify, history } = props
    modal.setCentered(false)
    modal.setHeaderText("系統提示")
    modal.setModalContent("是否確定取消詢價單？")

    modal.setOnSubmit(async () => {
      await updateOrder(updateOrderVariables("CANCEL"))

      notify.success("詢價單已取消")
      history.goBack()
    })
    modal.toggle()
  }

  const onSubmit = () => {
    const { modal, notify, history } = props
    modal.setCentered(false)
    modal.setHeaderText("系統提示")
    modal.setModalContent("是否確定送出詢價單？")

    modal.setOnSubmit(async () => {
      await updateOrder(updateOrderVariables("SUBMITTED"))

      notify.success("詢價單已送出")
      history.goBack()
    })
    modal.toggle()
  }

  return (
    <div>
      <DetailHeader data={data} />
      <Card>
        <CardHeader>
          <Row style={{ display: "flex", alignItems: "center" }}>
            <Col>
              <i className="mdi mdi-information-outline mr-2"> </i> 商品資訊
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <DetailItemList
            renderItems={() =>
              data?.order?.orderDetails.map(orderDetail => (
                <DetailItem
                  key={orderDetail.id}
                  orderDetails={data.order.orderDetails}
                  orderDetail={orderDetail}
                  writeData={writeData}
                  isAssistant={false}
                  readOnly={
                    data.order.status === "CANCEL" ||
                    data.order.status === "SUBMITTED"
                  }
                />
              ))
            }
          />
        </CardBody>
        <CardFooter>
          <BrowserView>
            <Row style={{ display: "flex", alignItems: "center" }}>
              <Col>
                <Button
                  color="primary"
                  onClick={onUpdate}
                  disabled={
                    data?.order?.status === "CANCEL" ||
                    data?.order?.status === "SUBMITTED"
                  }
                >
                  更新訂單
                </Button>
                <Button
                  color="danger"
                  className="ml-2 mr-2"
                  onClick={onCancel}
                  disabled={
                    data?.order?.status === "CANCEL" ||
                    data?.order?.status === "SUBMITTED"
                  }
                >
                  取消訂單
                </Button>
                <Button
                  color="success"
                  onClick={onSubmit}
                  disabled={
                    data?.order?.status === "CANCEL" ||
                    data?.order?.status === "SUBMITTED"
                  }
                >
                  確認送出
                </Button>
              </Col>
            </Row>
          </BrowserView>
          <MobileView>
            <Button
              color="primary"
              style={{ width: "100%" }}
              onClick={onUpdate}
              disabled={
                data?.order?.status === "CANCEL" ||
                data?.order?.status === "SUBMITTED"
              }
            >
              更新訂單
            </Button>
            <Button
              color="danger"
              style={{ width: "100%", marginTop: "5px", marginBottom: "5px" }}
              onClick={onCancel}
              disabled={
                data?.order?.status === "CANCEL" ||
                data?.order?.status === "SUBMITTED"
              }
            >
              取消訂單
            </Button>
            <Button
              color="success"
              style={{ width: "100%" }}
              onClick={onSubmit}
              disabled={
                data?.order?.status === "CANCEL" ||
                data?.order?.status === "SUBMITTED"
              }
            >
              確認送出
            </Button>
          </MobileView>
        </CardFooter>

        <BarLoader loading={updateOrderDetailsLoading || updateOrderLoading} />
      </Card>
      {(updateOrderDetailsError || updateOrderError) && (
        <Alert color="danger">
          錯誤訊息：{`${updateOrderDetailsError || updateOrderError}`}
        </Alert>
      )}
    </div>
  )
}

export default compose(
  withBreadcrumb,
  withRouter,
  withModal,
  withBasicNotify
)(OrderAuditClContainer)
